export const storeDetailScreenshots = [
  {
    id: "101",
    srcName: "STR001.png",
  },
  {
    id: "102",
    srcName: "STR002.png",
  },
  {
    id: "103",
    srcName: "STR003.png",
  },
  {
    id: "104",
    srcName: "STR004.png",
  },
  {
    id: "105",
    srcName: "STR005.png",
  },
  {
    id: "106",
    srcName: "STR006.png",
  },
  {
    id: "107",
    srcName: "STR007.png",
  },
  {
    id: "108",
    srcName: "STR008.png",
  },
  {
    id: "109",
    srcName: "STR009.png",
  },
  {
    id: "110",
    srcName: "STR010.png",
  },
  {
    id: "111",
    srcName: "STR011.png",
  },
  {
    id: "112",
    srcName: "STR012.png",
  },
  {
    id: "113",
    srcName: "STR013.png",
  },
  {
    id: "114",
    srcName: "STR014.png",
  },
  {
    id: "115",
    srcName: "STR015.png",
  },
  {
    id: "116",
    srcName: "STR016.png",
  },
  {
    id: "117",
    srcName: "STR017.png",
  },
  {
    id: "118",
    srcName: "STR018.png",
  },
  {
    id: "119",
    srcName: "STR019.png",
  },
  {
    id: "120",
    srcName: "STR020.png",
  },
  {
    id: "121",
    srcName: "STR021.png",
  },
  {
    id: "122",
    srcName: "STR022.png",
  },
  {
    id: "123",
    srcName: "STR023.png",
  },
  {
    id: "124",
    srcName: "STR024.png",
  },
  {
    id: "125",
    srcName: "STR025.png",
  },
  {
    id: "126",
    srcName: "STR026.png",
  },
];
